module.exports = __webpack_public_path__ + "e1b7b6fcb8cbe6f54266d52ab645a884.svg";